import { SetPreviouslyOrderedDataPayload, SetPreviouslyOrderedDataAction } from './interfaces'

export const SET_PREVIOUSLY_ORDERED_DATA = 'SET_PREVIOUSLY_ORDERED_DATA'

export const setPreviouslyOrderedData = (payload: SetPreviouslyOrderedDataPayload): SetPreviouslyOrderedDataAction => ({
  payload,
  type: SET_PREVIOUSLY_ORDERED_DATA,
})
